import { useEffect, useState } from 'react'

/**
 * Detect when the desktop layout should switch into a "condensed" mode.
 *
 * This is intentionally **width-based** (unlike `useIsMobile`, which is
 * pointer / device-type based) so that narrow desktop windows (e.g. split
 * view, Dia, side-by-side coding) can switch to a more compact chrome
 * without flipping into the full mobile experience.
 */
const useIsCondensed = (breakpoint = 1200) => {
  const [isCondensed, setIsCondensed] = useState(false)

  useEffect(() => {
    const check = () => {
      if (typeof window === 'undefined') {
        setIsCondensed(false)
        return
      }

      setIsCondensed(window.innerWidth < breakpoint)
    }

    check()

    window.addEventListener('resize', check)
    return () => {
      window.removeEventListener('resize', check)
    }
  }, [breakpoint])

  return isCondensed
}

export default useIsCondensed


